import { api } from './api';

export interface StorageQuotaSettingsDto {
  customerId: string;
  maxStoragePerUserBytes: number;
  globalMaxStorageBytes?: number | null;
  updatedAt: string;
}

export interface UpsertTenantStorageQuotaBody {
  maxStoragePerUserBytes: number;
  globalMaxStorageBytes?: number | null;
}

export interface TenantUserStorageUsageDto {
  userId: string;
  userName: string;
  email: string;
  totalFiles: number;
  totalSizeBytes: number;
  percentUsed: number;
}

class AdminTenantStorageService {
  async getQuota(): Promise<StorageQuotaSettingsDto | null> {
    try {
      const response = await api.get<StorageQuotaSettingsDto>('/admin/storage-quota');
      return response.data;
    } catch (e: unknown) {
      const ax = e as { response?: { status?: number } };
      if (ax.response?.status === 404) return null;
      throw e;
    }
  }

  async upsertQuota(body: UpsertTenantStorageQuotaBody): Promise<StorageQuotaSettingsDto> {
    const response = await api.put<StorageQuotaSettingsDto>('/admin/storage-quota', body);
    return response.data;
  }

  async listUserUsage(): Promise<TenantUserStorageUsageDto[]> {
    const response = await api.get<TenantUserStorageUsageDto[]>('/admin/storage-usage');
    return response.data ?? [];
  }
}

export const adminTenantStorageService = new AdminTenantStorageService();
